'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$() {
  this.aB0 = null;
  this.aB1 = false;
}
export { $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ as $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ };
$p = $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$;
/** @constructor */
function $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$() {
}
export { $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ as $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ };
$h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aB1)) {
    this.aB0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aB1 = true;
  }
  return this.aB0;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$, "app.data.DocumentaryCreditData$package$DocumentaryCreditNumber$", ({
  Dx: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ as $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ };
var $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$;
function $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$() {
  if ((!$n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$)) {
    $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ = new $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$();
  }
  return $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$;
}
export { $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ as $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$ };
//# sourceMappingURL=app.data.-Documentary-Credit-Data$package$-Documentary-Credit-Number$.js.map
